/**
 * One URI pipeline for every remote photo.
 *
 * `components/ui/Image` already rewrote Android-emulator loopback so
 * fixture covers on :5055 reach the AVD. PhotoLightbox used expo-image
 * directly, so pinch-zoom opened the raw localhost URL and the canvas
 * went blank. The rewrite lives here so a second viewer cannot skip it.
 *
 * Web also needs `image-orientation: from-image`. Browsers that ignore
 * EXIF show Android camera JPEGs on their side. Native expo-image already
 * orients; this CSS is the web half of the same contract.
 */
import { NativeModules, Platform } from 'react-native'
import * as Device from 'expo-device'
import {
  androidEmulatorAssetHost,
  metroOriginFromScriptURL,
  rewriteAndroidEmulatorLoopback,
} from './android-emulator-loopback'

export const WEB_EXIF_ORIENTATION_STYLE = (
  Platform.OS === 'web' ? { imageOrientation: 'from-image' } : {}
) as Record<string, string>

export function normalizeRemoteImageUri(
  source: string | number | null | undefined,
  options?: {
    os?: string
    isPhysicalDevice?: boolean
    assetHost?: string
    metroOrigin?: string
  },
): string | number | null {
  if (typeof source !== 'string') return source ?? null
  const value = source.trim()
  if (!value) return null

  const hasScheme = /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(value)
  if (hasScheme || value.startsWith('/')) {
    if (!hasScheme) return value
    const os = options?.os ?? Platform.OS
    const isPhysicalDevice = options?.isPhysicalDevice ?? Device.isDevice
    return rewriteAndroidEmulatorLoopback(value, {
      os,
      isPhysicalDevice,
      assetHost: options?.assetHost ?? androidEmulatorAssetHost(os, isPhysicalDevice),
      metroOrigin:
        options?.metroOrigin ??
        metroOriginFromScriptURL(NativeModules.SourceCode?.scriptURL) ??
        'http://10.0.2.2:8081',
    })
  }

  if (__DEV__) {
    console.warn(`[Tago] Image: invalid URI skipped (missing scheme): ${value}`)
  }
  return null
}
